import { useMutation } from "react-query";
import config from "../config";

const verifyEmailRequest = async (token) => {
  const response = await fetch(`${config.apiUrl}/verify`, {
    method: 'POST',
    body: JSON.stringify({token}),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    }
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || "Verification failed")
  }

  return await response.json();
  /*return {
    success: true,
    message: "User email verified",
  }*/
}

const useVerifyEmail = () => {
  return useMutation({
    mutationFn: async (token) => verifyEmailRequest(token),
  })
}

export default useVerifyEmail;